// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { baseUrl } from '../../../../../app.config'

// ** Axios Imports
import axios from 'axios'
import toast from 'react-hot-toast'

export const getCampaignList =
    createAsyncThunk(
        'campaign/getCampaignList',
        async () => {

            const response =
                await axios.get(
                    baseUrl() +
                    '/campaign/uploaded-files'
                )

            return {
                data: response.data.data
            }
        }
    )

export const allBusinessList = createAsyncThunk(
    'campaign/allBusinessList',
    async (params) => {
        const response = await axios.get(baseUrl() + '/banner', { params })
        return {
            params: response.data.params,
            allBusinessList: response.data.result
        }
    }
)

export const uploadTemplateFile = createAsyncThunk(
    'campaign/uploadTemplateFile',
    async (payload, { dispatch }) => {

        const formData = new FormData()

        formData.append(
            'audience',
            payload.audience
        )

        formData.append(
            'templateFile',
            payload.file
        )

        await axios.post(
            baseUrl() +
            '/campaign/upload-template',
            formData,
            {
                headers: {
                    'Content-Type':
                        'multipart/form-data'
                }
            }
        )

        toast.success(
            'Template uploaded successfully'
        )

        dispatch(
            getCampaignList()
        )

        return true
    }
)

export const deleteTemplateFile = createAsyncThunk(
    'campaign/deleteTemplateFile',
    async (payload, { dispatch }) => {

        await axios.delete(
            baseUrl() +
            `/campaign/uploaded-file/${payload?.id}`
        )

        toast.success(
            'Template deleted successfully'
        )

        dispatch(
            getCampaignList()
        )

        return true
    }
)

export const createCampaign =
    createAsyncThunk(
        'campaign/createCampaign',
        async (
            payload,
            { dispatch }
        ) => {

            await axios.post(
                baseUrl() +
                '/campaign/create',
                payload
            )

            toast.success(
                'Campaign created'
            )

            dispatch(
                getCampaignList()
            )

            return true
        }
    )

export const updateCampaign =
    createAsyncThunk(
        'campaign/updateCampaign',
        async (
            {
                id,
                payload
            },
            { dispatch }
        ) => {

            await axios.put(
                baseUrl() +
                `/campaign/update/${id}`,
                payload
            )

            toast.success(
                'Campaign updated'
            )

            dispatch(
                getCampaignList()
            )

            return true
        }
    )

export const deleteCampaign =
    createAsyncThunk(
        'campaign/deleteCampaign',
        async (
            id,
            { dispatch }
        ) => {

            await axios.delete(
                baseUrl() +
                `/campaign/delete/` + id
            )

            toast.success(
                'Campaign deleted'
            )

            dispatch(
                getCampaignList()
            )

            return true
        }
    )
export const campaign = createSlice({
    name: 'campaign',
    initialState: {
        campaignList: [],
        allBusinessList: [],
        reload: false,
        loader: false,
        rowsPerPage: 10,
        currentPage: 1,
        totalPages: 0,
        selected: null,
        clearFilter: false,
        status: '0',
        loading: false,
        params: {
            pageNo: 1,
            pageSize: 10
        },
        rowType: 'row1'


    },
    reducers: {
        selectCampaign: (state, action) => {
            if (action.payload === null) {
                state.selected = null
            } else {
                state.selected = action.payload
            }
        },
        selectCurrentPage: (state, action) => {
            if (action.payload === null) {
                state.currentPage = null
            } else {
                state.currentPage = action.payload
            }
        },
        selectRowsPerPage: (state, action) => {
            if (action.payload === null) {
                state.rowsPerPage = null
            } else {
                state.rowsPerPage = action.payload
            }
        },
        selectClearFilter: (state, action) => {
            state.clearFilter = action.payload
        },
        setStatus: (state, action) => {
            state.status = action.payload
        },
        setLoader: (state) => {
            state.loader = !state.loader
        },
        setLoading: (state, action) => {
            state.loading = action.payload
        },
        setRowType: (state, action) => {
            state.rowType = action.payload
        }
    },

    extraReducers: {
        [createCampaign.fulfilled]: (state, action) => {
            state.reload = !state.reload
        },
        [getCampaignList.fulfilled]: (state, action) => {
            state.campaignList = action.payload.data
            state.totalPages = action.payload.totalPages
            state.loader = false
        },
        [allBusinessList.fulfilled]: (state, action) => {
            state.allBusinessList = action.payload.allBusinessList
        },
        [updateCampaign.fulfilled]: (state, action) => {
            state.reload = !state.reload
            state.loader = false
        },
    }
})

export const { selectCampaign, selectRowsPerPage, selectCurrentPage, setStatus, setLoader,
    setLoading, selectClearFilter, setRowType } = campaign.actions

export default campaign.reducer
